var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-bar"},[_c('canvas',{ref:"loadingCanvas",attrs:{"width":"160","height":"160"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }